export default __webpack_public_path__ + "static/media/546.7bfbe1d4.png";